<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="export_ids" :value="export_ids" />
        <input type="input" name="fields" :value="fields" />
        <input type="input" name="order" :value="order" />
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_status" :value="where_status" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input
          type="input"
          name="where_unit_property"
          :value="where_unit_property"
        />
        <input type="input" name="where_job_type" :value="where_job_type" />
        <input type="input" name="where_pay" :value="where_pay" />
        <input type="input" name="where_employees" :value="where_employees" />
        <input type="input" name="where_turnover" :value="where_turnover" />
        <input
          type="input"
          name="where_organization_nation"
          :value="where_organization_nation"
        />
        <input
          type="input"
          name="where_organization_province"
          :value="where_organization_province"
        />
        <input
          type="input"
          name="where_organization_city"
          :value="where_organization_city"
        />
        <input
          type="input"
          name="where_organization"
          :value="where_organization"
        />
        <input type="input" name="where_position" :value="where_position" />
        <input
          type="input"
          name="where_registered_address"
          :value="where_registered_address"
        />
        <input type="input" name="where_freelance" :value="where_freelance" />
        <input
          type="input"
          name="where_mobile_phone"
          :value="where_mobile_phone"
        />
        <input type="input" name="where_wechat" :value="where_wechat" />
        <input
          type="input"
          name="where_origin_place"
          :value="where_origin_place"
        />
        <input
          type="input"
          name="where_alumni_type"
          :value="where_alumni_type"
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      export_ids: "",
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      fields: "",
      order: "",
      where_student_no: "",
      where_name: "",
      where_status: "",
      where_programme: "",
      where_unit_property: "",
      where_job_type: "",
      where_pay: "",
      where_employees: "",
      where_turnover: "",
      where_organization_nation: "",
      where_organization_province: "",
      where_organization_city: "",
      where_organization: "",
      where_position: "",
      where_registered_address: "",
      where_freelance: "",
      where_mobile_phone: "",
      where_wechat: "",
      where_origin_place: "",
      where_alumni_type: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(
      checkList,
      order,
      where_student_no,
      where_name,
      where_status,
      where_programme,
      where_unit_property,
      where_job_type,
      where_pay,
      where_employees,
      where_turnover,
      where_organization_nation,
      where_organization_province,
      where_organization_city,
      where_organization,
      where_position,
      where_registered_address,
      where_freelance,
      where_year,
      where_mobile_phone,
      where_wechat,
      where_origin_place,
      where_alumni_type,
      ids
    ) {
      if (ids) {
        this.export_ids = ids;
      } else {
        this.export_ids = "";
      }
      this.changVisible = true;
      this.fields = StrUtils.getJobInfoFields(checkList);
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;
      this.where_status = StrUtils.replaceFields(where_status.toString());
      this.where_programme = StrUtils.replaceFields(where_programme.toString());
      this.where_unit_property = StrUtils.replaceFields(
        where_unit_property.toString()
      );
      this.where_job_type = StrUtils.replaceFields(where_job_type.toString());
      this.where_pay = StrUtils.replaceFields(where_pay.toString());
      this.where_employees = StrUtils.replaceFields(where_employees.toString());
      this.where_turnover = StrUtils.replaceFields(where_turnover.toString());
      this.where_organization_nation = where_organization_nation;
      this.where_organization_province = where_organization_province;
      this.where_organization_city = where_organization_city;
      this.where_organization = where_organization;
      this.where_position = where_position;
      this.where_registered_address = where_registered_address;
      this.where_freelance = where_freelance;
      this.where_year =
        where_year.length == 0 ? "" : where_year[0] + "-" + where_year[1];
      // this.where_year = where_year;
      this.where_mobile_phone = where_mobile_phone;
      this.where_wechat = where_wechat;
      this.where_origin_place = where_origin_place;
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportAisJobInfo + "?token=" + this.token;
        from.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportAisJobInfoDialog.vue